export default {
  country: 'País',
  language: 'Idioma',
  currency: 'Moneda',
}
